import { hmac } from "@noble/hashes/hmac.js";
import { sha256 } from "@noble/hashes/sha2.js";
import { bytesToHex, utf8ToBytes } from "@noble/hashes/utils.js";

/**
 * hmacClient.ts
 *
 * PURPOSE:
 * --------
 * Creates HMAC signatures for pre-login requests.
 * Used ONLY for MFA / OTP flows.
 */

export const signRequest = (
  method: string,
  path: string,
  secret: string
) => {
  const timestamp = Date.now();

  const stringToSign = `${method.toUpperCase()}|${path}|${timestamp}`;

  const signature = bytesToHex(
    hmac(sha256, utf8ToBytes(secret), utf8ToBytes(stringToSign))
  );

  return {
    timestamp,
    signature,
  };
};
